<template>
  <div
    v-if="dialogInternal"
    class="load d-flex align-center justify-center"
    :style="'position: ' + position + '; left: 0; top: 0; z-index: 999999; width: 100%; height: 100%; background: #00000050;'"
  >
    <v-card
      id="CustomDialog"
      class="pa-5 d-flex flex-column"
      elevation="10"
      :style="'max-width: ' + (this.hasOnlyTextArea ? '600px' : '400px') + '; z-index: 1; max-height: ' + maxHeight + '; width: 100%; overflow-y: auto; overflow-x: hidden; border: 1px solid var(--v-foreground2-base); position: relative;'"
    >
      <div
        v-if="!noClose"
        class="close-button button d-flex align-center justify-center"
        @click="closeDialog=true"
      >
        <v-icon
          draggable="false"
          class="dialog-close-icon"
          color="background"
        >mdi-window-close</v-icon>
      </div>

      <h2
        v-if="title"
        class="text-center mb-5"
        style="width: 100%;"
      >{{ title }}</h2>

      <v-form
        ref="CustomDialog"
        v-if="isObject(template)"
        class="d-flex flex-column flex-wrap justify-center align-center px-3"
        style="width: 100%;"
        @submit="submit($event)"
      >
          <div
            v-for="(value, key) in template"
            :key="'category' + key + formUpdate"
            class="d-flex flex-column flex-wrap justify-center align-start"
            style="width: 100%;"
          >
            <div
              v-if="isTypeTrue(value.hidden)"
            ></div>

            <!-- <div
              v-else-if="isTypeTrue(value.disabled)"
              style="margin-top: -8px; margin-bottom: 14px; width: 100%; border-bottom: 1px solid var(--v-gray-base); cursor: not-allowed;"
            >
              <div style="color: var(--v-gray-base); font-size: 12px;">{{ value.label }}</div>
              <div style="color: var(--v-gray-base);">{{ formData[key] != null && formData[key].length > 0? (['select', 'autocomplete', 'combobox'].includes(value.type) && value.items.length > 0 && value.items.find(f => f.value === formData[key]) ? value.items.find(f => f.value === formData[key]).text : formData[key]) : '&nbsp;' }}</div>
            </div> -->

            <v-checkbox
              :ref="'Input' + key"
              v-else-if="value.type === 'checkbox' && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :hint="value.hint"
              persistent-hint
              dense
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <div
              v-else-if="value.type === 'switch' && checkDepends(key, value)"
              class="d-flex align-start justify-space-between"
              style="width: 100%;"
            >
              <span>{{ value.label ? value.label : key }}</span>
              <v-switch
                :ref="'Input' + key"
                v-model="formData[key]"
                class="mt-0 mb-4 py-0"
                style="border-radius: 0px;"
                :disabled="isTypeTrue(value.disabled) || loading"
                :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
                :hint="value.hint"
                persistent-hint
                @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
                @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
              />
            </div>


            <v-radio
              :ref="'Input' + key"
              v-else-if="value.type === 'radio' && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :hint="value.hint"
              persistent-hint
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <v-slider
              :ref="'Input' + key"
              v-else-if="value.type === 'slider' && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :hint="value.hint"
              persistent-hint
              :max="value.max ? value.max : 100"
              :min="value.min ? value.mine : 0"
              :step="value.step ? value.step : 1"
              :thumb-label="value.thumb ? value.thumb : null"
              :ticks="value.ticks ? value.ticks : null"
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <div
              :ref="'Input' + key"
              v-else-if="value.type === 'list' && checkDepends(key, value) && Array.isArray(formData[key])"
              class="mb-4"
              style="width: 100%;"
            >

              <h4>{{ value.label }}</h4>

              <div
                v-for="(item, index) in formData[key]"
                :key="'List' + key + index + formData[key].length"
                class="mb-4"
                style="position: relative; width: 100%; border: 1px solid var(--v-foreground2-base); padding: 10px; margin-bottom: 10px;"
              >

                <v-btn
                  v-if="typeof template[key].min !== 'number' || (typeof template[key].min === 'number' && formData[key].length > template[key].min)"
                  @click="removeListItem(key, index)"
                  color="red"
                  dark
                  small
                  class="mb-4"
                  style="position: absolute; right: -12px; top: -12px; border-radius: 50%; width: 24px; height: 24px; min-width: 24px !important; min-height: 24px !important;"
                ><v-icon small>mdi-close</v-icon></v-btn>

                <v-text-field
                  v-for="subKey in Object.keys(item)"
                  :key="'List' + key + index + formData[key].length + subKey"
                  v-model="item[subKey]"
                  :label="template[key].template[subKey].label"
                  style="width: 100%;"
                  :rules="template[key].template[subKey].rules || []"
                  dense
                  single-line
                />
              </div>

              <v-btn
                v-if="typeof template[key].max !== 'number' || (typeof template[key].max === 'number' && formData[key].length < template[key].max)"
                @click="addListItem(key)"
                color="blue"
                dark
                small
                class="mb-4"
                style="width: 100%;"
              >Add</v-btn>
            </div>

            <v-select
              :ref="'Input' + key"
              v-else-if="(value.type === 'select' || (value.type === 'type' && formData.type === 'select')) && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%; z-index: 999999;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :items="value.items"
              :item-text="value['item-text'] ? value['item-text'] : 'text'"
              :item-value="value['item-value'] ? value['item-value'] : 'value'"
              :hint="value.hint"
              :multiple="value.multiple"
              :filled="value.filled"
              persistent-hint
              dense
              :rules="value.rules"
              :append-outer-icon="value.refresh ? 'mdi-refresh' : ''"
              @click:append-outer="$emit('refreshItems', key)"
              @change="value.onchange === 'updateItems' ? updateItems(key, value.updateItems) : value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />
            <div
              v-else-if="value.type === 'select'"
            >{{ formData[value.depends] }}</div>

            <v-autocomplete
              :ref="'Input' + key"
              v-else-if="(value.type === 'autocomplete' || (value.type === 'type' && formData.type === 'autocomplete')) && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%; z-index: 999999;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :items="value.items"
              :item-text="value['item-text'] ? value['item-text'] : 'text'"
              :item-value="value['item-value'] ? value['item-value'] : 'value'"
              :hint="value.hint"
              :multiple="value.multiple"
              :filled="value.filled"
              persistent-hint
              dense
              :rules="value.rules"
              :append-outer-icon="value.refresh ? 'mdi-refresh' : ''"
              @click:append-outer="$emit('refreshItems', key)"
              @change="value.onchange === 'updateItems' ? updateItems(key, value.updateItems) : value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <v-combobox
              :ref="'Input' + key"
              v-else-if="(value.type === 'combobox' || (value.type === 'type' && formData.type === 'combobox')) && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%; z-index: 999999;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :items="value.items"
              :item-text="value['item-text'] ? value['item-text'] : 'text'"
              :item-value="value['item-value'] ? value['item-value'] : 'value'"
              :hint="value.hint"
              :multiple="value.multiple"
              :filled="value.filled"
              persistent-hint
              dense
              :rules="value.rules"
              :append-outer-icon="value.refresh ? 'mdi-refresh' : ''"
              @click:append-outer="$emit('refreshItems', key)"
              @change="value.onchange === 'updateItems' ? updateItems(key, value.updateItems) : value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <v-text-field
              :ref="'Input' + key"
              v-else-if="(value.type === 'password' || (value.type === 'type' && formData.type === 'password')) && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :type="metadata[key].show ? 'text' : 'password'"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :hint="value.hint"
              :prefix="value.prefix"
              :suffix="value.suffix"
              persistent-hint
              :rules="value.rules"
              :append-icon="metadata[key].show ? 'mdi-eye' : 'mdi-eye-off'"
              dense
              @click:append="toggleHidden(key)"
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <v-text-field
              :ref="'Input' + key"
              v-else-if="(value.type === 'number' || (value.type === 'type' && (formData.type === 'int' || formData.type === 'float'))) && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              type="number"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :placeholder="value.placeholder"
              :prefix="value.prefix"
              :suffix="value.suffix"
              :hint="value.hint"
              persistent-hint
              :rules="value.rules"
              dense
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <v-text-field
              :ref="'Input' + key"
              v-else-if="(value.type === 'email' || (value.type === 'type' && formData.type === 'email')) && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              type="email"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :placeholder="value.placeholder"
              :prefix="value.prefix"
              :suffix="value.suffix"
              :hint="value.hint"
              persistent-hint
              :rules="value.rules"
              dense
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <v-text-field
              :ref="'Input' + key"
              v-else-if="(value.type === 'string' || (value.type === 'type' && formData.type === 'string')) && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :placeholder="value.placeholder"
              :prefix="value.prefix"
              :suffix="value.suffix"
              :hint="value.hint"
              persistent-hint
              :rules="value.rules"
              dense
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <v-textarea
              :ref="'Input' + key"
              v-else-if="(value.type === 'textarea' || (value.type === 'type' && formData.type === 'textarea')) && checkDepends(key, value)"
              v-model="formData[key]"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              outlined
              :rows="value.rows"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :placeholder="value.placeholder"
              :hint="value.hint"
              persistent-hint
              dense
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

            <v-text-field
              :ref="'Input' + key"
              v-else-if="checkDepends(key, value)"
              v-model="formData[key]"
              :type="value.type"
              class="mb-4"
              style="border-radius: 0px; width: 100%;"
              :disabled="isTypeTrue(value.disabled) || loading"
              :hide-details="(!value.hint && (!value.rules || value.rules.length > 1 || (value.rules.length === 1 && value.required))) || isTypeTrue(value.disabled)"
              :label="value.label ? value.label + (value.required ? ' *' : '') : key"
              :placeholder="value.placeholder"
              :prefix="value.prefix"
              :suffix="value.suffix"
              :hint="value.hint"
              persistent-hint
              :rules="value.rules"
              dense
              @change="value.onchange === 'emit' ? emitValue('change-' + key, formData[key]) : updateForm(key, $event)"
              @blur="value.blur === 'emit' ? emitValue('blur-' + key, formData[key]) : () => {}"
            />

          </div>

        <v-btn
          ref="SubmitButton"
          id="Submit"
          class="mx-auto mt-3"
          style="min-width: 150px;"
          @click="submit($event)"
          color="blue"
          dark
          :loading="loading"
        >{{ buttonText }}</v-btn>

      </v-form>

    </v-card>
    <div
      v-if="!flat"
      id="Background"
      class="clear"
      style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; cursor: pointer;"
      @click="closeDialog=true;"
    ></div>
  </div>
</template>
<script>

export default {
  name: 'CustomDialog',

  components: {

  },

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: false,
      default: Object,
    },
    title: {
      type: String,
      required: false,
    },
    headers: {
      type: Array,
      required: true,
      default: () => [],
    },
    itemTemplate: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: '',
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Submit',
    },
    flat: {
      type: Boolean,
      required: false,
      default: false,
    },
    form: {
      type: Boolean,
      required: false,
      default: false,
    },
    noClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    blockInput: {
      type: Boolean,
      required: false,
      default: false,
    },
    saveOnSubmit: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data: () => ({
    dialogInternal: false,
    closeDialog: false,
    formData: {},
    position: 'fixed',
    maxHeight: '80%',
    metadata: {},
    formUpdate: 0,
    comboboxKey: 0,
    autocompleteKey: 0,
    selectKey: 0,
    hasOnlyTextArea: true,
    template: {},
  }),

  watch: {
    item(o) {
      this.setFormData(o);
      this.$forceUpdate();
    },

    itemTemplate(o) {
      this.setFormTemplate(o);
    },

    dialog(e) {
      this.dialogInternal = e;
      this.resetFormData();
      if (e) {
        this.$nextTick(() => {
          for (const key of Object.keys(this.template)) {
            const ref = 'Input' + key;
            if (this.$refs[ref] && this.$refs[ref].length > 0) {
              this.$refs[ref][0].focus();
              break;
            }
          }
        })
      }
    },

    dialogInternal(e) {
      if (!e) {
        this.$emit('dialog', false);
      }
    },

    closeDialog(v) {
      if (v) {
        if (!this.noClose) {
          this.dialogInternal = false;
          this.closeDialog = false;
        }
        this.$emit('dialog', false);
      }
    }
  },

  methods: {
    isObject(val) {
      return val !== null && typeof val === 'object' && !Array.isArray(val);
    },

    isTypeTrue(value) {
      return typeof value === 'object' ? (this.type === 'add' && value.add) || (this.type === 'edit' && value.edit) : value ? true : false;
    },

    updateForm(key, value) {
      for (const [k, v] of Object.entries(this.template)) {
        if (v.depends && v.depends[key]) {
          this.formUpdate = new Date().getTime();
          this.$forceUpdate();
          break;
        }
      }

      this.$nextTick(() => {
        if (this.$refs['Input' + key] && this.$refs['Input' + key].length > 0) {
          this.$refs['Input' + key][0].focus();
        }
      })
    },

    checkDepends(key, value) {
      if ( value.depends === undefined ||
      (
        Object.entries(value.depends).every(([k, v]) =>
          (Array.isArray(v) && v.includes(this.formData[k])) ||
          (typeof v === 'string' && this.formData[k] === v) ||
          (typeof v === 'function' && v(this.formData[k]))
        )
      )) {
        this.setDefaultValue(key);
        return true;
      }

      this.formData[key] = undefined;
      return false;
    },

    checkIf(key) {
      for (const v of Object.values(this.template)) {
        if (v.if === key) {
          this.formUpdate = new Date().getTime();
          this.$forceUpdate();
          break;
        }
      }
    },

    setFormData(o) {
      if (!o) return;

      for (const [key, value] of Object.entries(o)) {
        if (key in this.formData) {
          let tmp = value;

          if (tmp && typeof tmp === 'string' && this.template[key].prefix) {
            tmp = tmp.replace(new RegExp('^' + this.template[key].prefix.replace('+', '\\+')), '');
          }
          if (tmp && typeof tmp === 'string' && this.template[key].suffix) {
            tmp = tmp.replace(new RegExp(this.template[key].suffix.replace('+', '\\+') + '$'), '');
          }

          if (this.template[key].type === 'date') {
            tmp = new Date(tmp).toISOString().split('T')[0];
          }
          else if (this.template[key].type === 'time') {
            tmp = new Date(tmp).toISOString().split('T')[1].split('.')[0];
          }
          else if (this.template[key].type === 'datetime' || this.template[key].type === 'datetime-local') {
            if (tmp != null) {
              tmp = new Date(tmp).toISOString().split('.')[0];
            }
          }

          this.formData[key] = tmp;
        }
      }

      this.formKey = new Date().getTime();
    },

    setDefaultValue(key) {
      if ((this.formData[key] == null || ((typeof this.formData[key] === String || Array.isArray(this.formData[key])) && this.formData[key].length === 0)) && this.template[key].default != null) {
        if (typeof this.template[key].default === 'function') {
          this.formData[key] = this.template[key].default();
        }
        else {
          if (this.template[key].type === 'date') {
            if (this.template[key].default === 'today') {
              const today = new Date();
              this.formData[key] = today.toISOString().split('T')[0];
            } else {
              this.formData[key] = this.template[key].default;
            }
          }
          else if (this.template[key].type === 'time') {
            if (this.template[key].default === 'now') {
              const now = new Date();
              this.formData[key] = now.toISOString().split('T')[1].split('.')[0];
            } else {
              this.formData[key] = this.template[key].default;
            }
          }
          else if (this.template[key].type === 'datetime' || this.template[key].type === 'datetime-local') {
            if (this.template[key].default === 'now') {
              const now = new Date();
              this.formData[key] = now.toISOString().split('.')[0];
            } else {
              this.formData[key] = this.template[key].default;
            }
          }
          else {
            this.formData[key] = this.template[key].default;
          }
        }
      }
    },

    setFormTemplate(o) {
      this.template = {};

      for (const [key, value] of Object.entries(o)) {
        this.template[key] = value;
        this.setDefaultValue(key);
      }

      for (const key of Object.keys(this.template)) {
        if (this.template[key].type !== 'textarea') this.hasOnlyTextArea = false;
        if (this.template[key].required === true) {
          if (!Array.isArray(this.template[key])) this.template[key].rules = [];
          this.template[key].rules.unshift(v => v != null && v != '' || 'Required field.')
        }
      }

      for (const head of this.headers) {
        if (this.template[head.value]) {
          this.template[head.value].label = head.text;
        }
      }
    },

    emitValue(key, value) {
      this.$emit(key, value);
    },

    updateItems(readKey, writeKey) {
      this.template[writeKey].items = this.template[writeKey].itemList[this.formData[readKey]];
      this.formUpdate = new Date().getTime();
      this.$forceUpdate();
    },

    toggleHidden(key) {
      this.metadata[key].show = !this.metadata[key].show;
      this.formUpdate = new Date().getTime();
      this.$forceUpdate();
    },

    validDate(date) {
      const match = date.match(/(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        const year = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1; // Months are 0-indexed in JavaScript
        const day = parseInt(match[3], 10);
        const d = new Date(year, month, day);
        const ret = d.getFullYear() === year && d.getMonth() === month && d.getDate() === day;
        if (!ret) {
          console.warn('Invalid date:', date, '. Expected format: YYYY-MM-DD');
        }
        return ret;
      }

      console.warn('Invalid date format:', date, '. Expected format: YYYY-MM-DD');
      return false;
    },

    validTime(time) {
      const match = time.match(/(\d{2}):(\d{2})(:(\d{2}))?/);
      if (match) {
        const hours = parseInt(match[1], 10);
        const minutes = parseInt(match[2], 10);
        const seconds = match[4] ? parseInt(match[4], 10) : 0;
        const ret = hours >= 0 && hours < 24 && minutes >= 0 && minutes < 60 && seconds >= 0 && seconds < 60;
        if (!ret) {
          console.warn('Invalid time:', time, '. Expected format: HH:MM[:SS]');
        }
        return ret;
      }

      console.warn('Invalid time format:', time, '. Expected format: HH:MM[:SS]');
      return false;
    },

    submit(e) {
      if (e) e.preventDefault();
      if (this.$refs.CustomDialog.validate()) {
        for (const key of Object.keys(this.template)) {
          if (this.template[key].type === 'date' && !this.validDate(this.formData[key])) {
            this.$refs['Input' + key][0].focus();
            return;
          }
          if (this.template[key].type === 'time' && !this.validTime(this.formData[key])) {
            this.$refs['Input' + key][0].focus();
            return;
          }
          if (this.formData[key] && typeof this.formData[key] === 'string' && ((this.template[key].type === 'datetime' || this.template[key].type === 'datetime-local') && (!this.validDate(this.formData[key].split('T')[0]) || !this.validTime(this.formData[key].split('T')[1])))) {
            this.$refs['Input' + key][0].focus();
            return;
          }
        }
        this.prepareSubmit();
        this.$nextTick(() => {
          this.$emit('submit', this.formData);
          this.resetFormData();
        })
      }
    },

    addListItem(key) {
      const o = {};
      for (const [k, v] of Object.entries(this.template[key].template)) {
        o[k] = v.default;
      }
      this.formData[key].push(o);
      this.formUpdate = new Date().getTime();
      this.$forceUpdate();
    },

    removeListItem(key, index) {
      this.formData[key].splice(index, 1);
      this.formUpdate = new Date().getTime();
      this.$forceUpdate();
    },

    prepareSubmit() {
      for (const [key, value] of Object.entries(this.template)) {
        if (this.isTypeTrue(value.disabled) || this.isTypeTrue(value.hidden) || (value.depends && !this.checkDepends(key, value))) {
          continue;
        }

        if (/number/i.test(value.type)) { // This is for the case when the input is a string but the template is a number
          this.formData[key] = parseFloat(this.formData[key]);
        }
        else if (/string|email|combobox|autocomplete|select/i.test(value.type)) { // This is to allow the changing of value if the input hasn't been "changed" yet
          if (/^\w+$/.test(key) && this.$refs['Input' + key] && this.$refs['Input' + key].length > 0) {
            this.$refs['Input' + key][0].blur();
            this.$forceUpdate();
          }

          if (!this.formData[key] || this.formData[key] === '') {
            this.formData[key] = (this.template[key].allowNull ? null : '');
          }
        }
        else if (['datetime', 'datetime-local', 'time'].includes(value.type)) {
          this.formData[key] = new Date(this.formData[key]).toISOString();
        }

        // This is to add the prefix and suffix to the value
        if (value.prefix && value.keepPrefix && this.formData[key] && this.formData[key] !== '') {
          this.formData[key] = value.prefix + this.formData[key];
        }
        if (value.suffix && value.keepSuffix && this.formData[key] && this.formData[key] !== '') {
          this.formData[key] += value.suffix;
        }

        // Convert key to the alias if it exists
        if (value.alias) {
          this.formData[value.alias] = this.formData[key];
          delete this.formData[key];
        }
      }
    },

    resetFormData() {
      this.formData = {};
      if (this.item) {
        for (const [key, value] of Object.entries(this.template)) {
          this.formData[key] = this.template[key].default;
          this.metadata[key] = {};
          if (this.template[key].type === 'password') {
            this.metadata[key].show = false;
          }
          if (value.alias) {
            delete this.formData[value.alias];
          }
        }

        if (Object.keys(this.item).length > 0 || this.saveOnSubmit) {
          this.setFormData(this.item);
        }
      }

      this.formUpdate = new Date().getTime()
      this.$forceUpdate();
    },

    keyup(e) {
      if (this.dialogInternal) {
        // Get focused element, if it is a textarea do not submit on enter
        const activeElement = document.activeElement;
        if (e.key === 'Enter' && activeElement && activeElement.tagName.toLowerCase() === 'textarea') {
          return;
        }
        if (e.key === 'Enter') {
          for (const key of Object.keys(this.template)) {
            if (this.$refs['Input' + key] && this.$refs['Input' + key].length > 0) {
              this.$refs['Input' + key][0].blur();
            }
          }
          this.submit();
        }
      }
    },

    keydown(e) {
      if (this.dialogInternal) {
        if (e.key === 'Escape') {
          this.closeDialog = true;
        }
      }
    }
  },

  destroyed() {
    window.removeEventListener('keyup', this.keyup);
    window.removeEventListener('keydown', this.keydown);
  },

  created() {
    window.addEventListener('keyup', this.keyup);
    window.addEventListener('keydown', this.keydown);
    if (this.form) {
      this.position = 'relative';
      this.maxHeight = '100%';
    }
    this.dialogInternal = false;
    this.$emit('dialog', false);
  },

  mounted() {
    this.setFormTemplate(this.itemTemplate);
    this.resetFormData();
  }
}
</script>
<style scoped>
  .theme--dark.v-icon {
    color: var(--v-background-base);
  }
  .theme--dark.v-icon:hover {
    color: #FFFFFF;
  }
  .v-input--selection-controls__ripple {
    margin: 0 !important;
  }
  .close-button {
    cursor: pointer;
    position: absolute;
    top: -1px;
    right: -1px;
    height: 30px;
    width: 40px;
    border-radius: 0 0 0 3px;
    background: var(--v-red-base);
  }
  .close-button:hover {
    opacity: 0.7;
  }
</style>
